module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.8229/js/img/SalesHub_Icon.svg"